<template>
  <div>
    <div class="pt-5 pb-5" v-if="isMobileOrTablet">
      <appHeader></appHeader>
      <div class="container program">
        <transition appear name="fade">
          <div class="row">
            <div class="col-md-12 py-4">
              <h4 v-html="programNameHtml"></h4>
              <div class="row col-12 program-description mt-4">
                <div class="col-12 p-0" v-html="programDesc"></div>
                <p v-if="companyName == 'Pentair'"><b>NOTE:</b> $1 earned as a reward in the myHC360+ app = 1 Rewards Mall point.</p>
              </div>
            </div>
          </div>
        </transition>
      </div>
      <!-- /.container -->
      <appFooter></appFooter>
      <navigationFooter></navigationFooter>
    </div>
    <div class="mt-5" v-else>
      <appHeader></appHeader>
      <div class="container program">
        <transition appear name="fade">
          <div class="row">
            <div class="col-md-12 py-4">
              <h4 v-html="programNameHtml"></h4>
              <div class="row col-12 program-description mt-4">
                <div class="col-12 p-0" v-html="programDesc"></div>
                <p v-if="companyName == 'Pentair'"><b>NOTE:</b> $1 earned as a reward in the myHC360+ app = 1 Rewards Mall point.</p>
              </div>
            </div>
          </div>
        </transition>
      </div>
      <!-- /.container -->
      <appFooter></appFooter>
    </div>
  </div>
</template>

<script>
import Header from "@/components/Header.vue";
import Footer from "@/components/Footer.vue";
import { isMobile,isTablet } from "mobile-device-detect";
import navigationFooter from "../../components/navigationFooter.vue";

export default {
  data() {
    return {
      programNameHtml: this.$store.state.company.programNameHtml || "Program",
      programDesc: this.$store.state.company.programDescriptionHtml,
      companyName: this.$store.state.company.name,
    };
  },
  computed: {
    isMobileOrTablet: function() {
      return isMobile || isTablet
    },
  },
  components: {
    appHeader: Header,
    appFooter: Footer,
    navigationFooter: navigationFooter,
  },
  created() {
    this.$store.dispatch("company/fetchCompany");
  },
};
</script>

<style lang="scss" scoped>
.container {
  min-height: 75vh;
}
</style>

<style lang="scss">
.program-description {
  h1,
  h2,
  h3,
  h4,
  h5,
  h6 {
    &::after {
      display: none;
    }
  }
}
</style>
